import { render, staticRenderFns } from "./filter-space.vue?vue&type=template&id=b8e072ce&scoped=true"
import script from "./filter-space.vue?vue&type=script&lang=js"
export * from "./filter-space.vue?vue&type=script&lang=js"
import style0 from "./filter-space.vue?vue&type=style&index=0&id=b8e072ce&prod&scoped=true&lang=scss"
import style1 from "./filter-space.vue?vue&type=style&index=1&id=b8e072ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e072ce",
  null
  
)

export default component.exports